/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import {
    CognitoUserPool,
    CognitoUserAttribute,
    CognitoUser,
    AuthenticationDetails
} from 'amazon-cognito-identity-js';

import { getCognitoCredential } from '../http/baseUrl';


var userPool = new CognitoUserPool(getCognitoCredential());

export function checkSession() {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {
                if (err) {
                    cognitoUser.globalSignOut({
                        onSuccess: (msg) => {
                            reject("セッションが切れています。")
                        },
                        onFailure: (err) => {
                            reject("エラーが発生しました。")
                        }
                    })
                }
                resolve(session)
            });
        } else {
            reject("エラーが発生しました。")
        }
    })

}

export function login(username, password) {
    var authenticationData = {
        Username: username,
        Password: password,
    };
    var authenticationDetails = new AuthenticationDetails(
        authenticationData
    );

    var userData = {
        Username: username,
        Pool: userPool,
    };

    return new Promise((resolve, reject) => {
        var cognitoUser = new CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                resolve({ type: "success", result: result })
            },

            onFailure: function (err) {
                console.log(err)
                reject(err)
            },
            totpRequired: function (secretCode) {
                resolve({ type: "totpRequired" })
            },
            newPasswordRequired: function(userAttributes) {
                let attributes = []
                Object.keys(userAttributes).forEach(k => {
                    if (userAttributes.hasOwnProperty(k) && k !== "email_verified" && k !== "email") {
                        attributes[k] = userAttributes[k]
                    }
                })
                resolve({type: "newPasswordRequired", userAttributes: attributes, cognitoUser: cognitoUser})
            }
        });
    })
}

export function loginWithTotp(username, password, totp) {
    var authenticationData = {
        Username: username,
        Password: password,
    };
    var authenticationDetails = new AuthenticationDetails(
        authenticationData
    );

    var userData = {
        Username: username,
        Pool: userPool,
    };

    return new Promise((resolve, reject) => {
        var cognitoUser = new CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                resolve({ type: "success", result: result })
            },

            onFailure: function (err) {
                reject(err)
            },
            totpRequired: function (secretCode) {
                cognitoUser.sendMFACode(totp, this, 'SOFTWARE_TOKEN_MFA');
            },
        });
    })

}

export function completeNewPasswordChallenge(password, userAttributes, cognitoUser) {
    return new Promise((resolve, reject) => {
        cognitoUser.completeNewPasswordChallenge(password, userAttributes, {
            onSuccess: function (result) {
                resolve({ type: "success", result: result })
            },

            onFailure: function (err) {
                console.log(err)
                reject(err)
            },
            totpRequired: function (secretCode) {
                resolve({ type: "totpRequired" })
            },
            newPasswordRequired: function(userAttributes) {
                let attributes = []
                Object.keys(userAttributes).forEach(k => {
                    if (userAttributes.hasOwnProperty(k) && k !== "email_verified" && k !== "email") {
                        attributes[k] = userAttributes[k]
                    }
                })
                resolve({type: "newPasswordRequired", userAttributes: attributes, cognitoUser: cognitoUser})
            }
        });
    })
}

export function signout() {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {
                if (session) {
                    cognitoUser.signOut()
                } else {
                    reject("エラーが発生しました。")
                }
            });
        } else {
            reject("エラーが発生しました。")
        }
    })
}

export function forgotPassword(username) {
    var userData = {
        Username: username,
        Pool: userPool,
    };

    return new Promise((resolve, reject) => {
        var cognitoUser = new CognitoUser(userData);
        cognitoUser.forgotPassword({
            onSuccess: (data) => {
                resolve({ type: "success", data: data })
            },
            onFailure: (err) => {
                reject(err)
            },
            inputVerificationCode: (result) => {
                resolve({ type: "inputVerificationCode", data: result.CodeDeliveryDetails.Destination })
            }
        })
    })
}


export function confirmPassword(username, newPassword, confirmCode) {
    var userData = {
        Username: username,
        Pool: userPool,
    };

    return new Promise((resolve, reject) => {
        var cognitoUser = new CognitoUser(userData);
        cognitoUser.confirmPassword(confirmCode, newPassword, {
            onSuccess: (data) => {
                resolve({ type: "success", data: data })
            },
            onFailure: (err) => {
                reject(err)
            },
        })
    })
}

export function changePassword(oldPass, newPass) {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();

        cognitoUser.getSession(function (err, session) {
            if (session && session.isValid()) {
                cognitoUser.changePassword(oldPass, newPass, function (err, result) {
                    if (err) {
                        console.log(err)
                        reject(err)
                    } else {
                        resolve({ type: "success" })
                    }
                });
            } else {
                reject(new Error("cannot change password"))
            }
        })

    })

}

export function getMfaState() {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();

        cognitoUser.getSession(function (err, session) {
            if (session && session.isValid()) {
                cognitoUser.getUserData((err, data) => {
                    if (err) {
                        reject(err)
                    }

                    const { PreferredMfaSetting } = data;
                    console.log(data)
                    if (PreferredMfaSetting != "SOFTWARE_TOKEN_MFA") {
                        resolve({ type: "success", data: false })
                    } else {
                        resolve({ type: "success", data: true })
                    }
                }, { bypassCache: true });
            } else {
                reject(new Error("cannot get mfa state"))
            }
        })

    })

}

export function associateSoftwareToken() {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();

        cognitoUser.getSession(function (err, session) {
            if (session && session.isValid()) {
                cognitoUser.getUserData((err, data) => {
                    if (err) {
                        reject(err)
                    }

                    let username = ""
                    data.UserAttributes.forEach(attr => {
                        if (attr.Name.toLowerCase() == "email") {
                            username = attr.Value
                        }
                    });
                    cognitoUser.associateSoftwareToken({
                        associateSecretCode: function (secretCode) {
                            console.info("AssociateSecretCode");
                            console.info("Display QR Code");

                            const url = `otpauth://totp/${username}?secret=${secretCode}&issuer=Cognito-TOTP-MFA`;
                            console.info("Your secret Code: " + secretCode);

                            resolve({ type: "success", data: url })
                        },
                        onFailure: function (err) {
                            reject(err)
                        },
                    });
                }, { bypassCache: true });
            } else {
                reject(new Error("cannot associate software token"))
            }
        })

    })

}

export function enableMfa(confirmCode) {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();

        const totpMfaSettings = {
            PreferredMfa: true,
            Enabled: true,
        };

        const enableMFA = () => {
            cognitoUser.setUserMfaPreference(
                null,
                totpMfaSettings,
                function (err, result) {
                    if (err) {
                        reject(err)
                    }

                    resolve({ type: "success" })
                }
            );
        };

        cognitoUser.getSession(function (err, session) {
            if (session && session.isValid()) {
                cognitoUser.verifySoftwareToken(
                    confirmCode,
                    "My TOTP device",
                    {
                        onFailure: function (err) {
                            reject(err)
                        },
                        onSuccess: function (result) {
                            enableMFA();
                        },
                    }
                );
            } else {
                reject(new Error("cannot associate software token"))
            }
        })

    })

}

export function disableMfa() {
    return new Promise((resolve, reject) => {
        var cognitoUser = userPool.getCurrentUser();

        const totpMfaSettings = {
            PreferredMfa: false,
            Enabled: false,
        };

        cognitoUser.getSession(function (err, session) {
            if (err) {
                return reject(err)
            }
            cognitoUser.setUserMfaPreference(
                null,
                totpMfaSettings,
                function (err, result) {
                    if (err) {
                        return reject (err)
                    }
                    resolve ({type: "success"})
                }
            );
        })

    })

}